import { Button, Col, Modal, Row, Image } from 'react-bootstrap'
import { useState, useEffect, useRef } from 'react'
import { toast } from 'react-toastify'
import { ArrowRightCircle } from 'react-bootstrap-icons'
import { useParams } from 'react-router-dom'
import { useSelector } from "react-redux"
import userImg from '../../../assets/user.png'
import Select from 'react-select';

export default function Timer({ agenda, item, getMeeting }) {
    const { user: authUser } = useSelector(x => x.auth)
    const url = process.env.REACT_APP_URL

    // console.log(agenda)
    // console.log(item)
    // console.log(item.timer?.time)


    const meetingId = useParams().meetingId

    const [currentIndex, setCurrentIndex] = useState(
        agenda.findIndex(agendaItem => agendaItem.agendaItemId === item.agendaItemId)
    );

    const currentItem = agenda[currentIndex];

    const dropdownRef = useRef(null); // Create a ref for the dropdown container

    // Handle navigation to the next item
    const handleNextItem = () => {
        if (currentIndex < agenda.length - 1) {
            setCurrentIndex(currentIndex + 1);
        }
    };

    // Handle navigation to the previous item
    const handlePreviousItem = () => {
        if (currentIndex > 0) {
            setCurrentIndex(currentIndex - 1);
        }
    };

    const [showModal, setShowModal] = useState(false)
    const [isPlaying, setIsPlaying] = useState(false)
    const [isInitial, setIsInitial] = useState(true)
    const [isLocked, setIsLocked] = useState(false)
    const [showClock, setShowClock] = useState(true) // State to manage clock visibility
    const [time, setTime] = useState(0) // State to manage time in seconds
    const [backgroundColor, setBackgroundColor] = useState("rgba(0, 0, 0, 0)") // State to manage background color
    const intervalRef = useRef(null) // Reference to store the interval ID
    const [showRoleDescription, setShowRoleDescription] = useState(false) // State to manage description visibility
    const [showEventDescription, setShowEventDescription] = useState(false)
    const [showDropdown, setShowDropdown] = useState(false); // State to toggle dropdown visibility
    const [presenters, setPresenters] = useState({ officersAndMembers: [], guests: [] })
    // const [selectedRoleId, setSelectedRoleId] = useState('')
    const [selectedPresenterId, setSelectedPresenterId] = useState('')

    // const [timer, setTimer] = useState(0)

    const toggleRoleDescription = () => setShowRoleDescription(!showRoleDescription) // Toggle description visibility
    const toggleEventDescription = () => setShowEventDescription(!showEventDescription)

    const handleCloseModal = () => setShowModal(false)
    const handleShowModal = () => {
        // Update the currentIndex based on the item passed to the Timer component
        const newIndex = agenda.findIndex(agendaItem => agendaItem.agendaItemId === item.agendaItemId);
        setCurrentIndex(newIndex);
        setShowModal(true);
    };
    const togglePlayPause = () => setIsPlaying(!isPlaying)
    const toggleShowClock = () => setShowClock(!showClock) // Toggle clock visibility


    const getPresenters = async () => {
        const response = await fetch(`${url}/users`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authUser.token}`
            }
        })
        if (response.status === 200) {
            const presenters = await response.json()
            // Group presenters by role
            const officersAndMembers = presenters.filter(p => p.acl === 'Officer' || p.acl === 'Member').sort((a, b) => a.firstName.localeCompare(b.firstName))
            const guests = presenters.filter(p => p.acl === 'Guest').sort((a, b) => a.firstName.localeCompare(b.firstName))
            setPresenters({ officersAndMembers, guests })
        }
        else {
            console.log(response)
        }
    }

    const presenterOptions = [
        {
            label: 'Members',
            options: presenters.officersAndMembers.map(presenter => ({ value: presenter._id, label: `${presenter.firstName} ${presenter.lastName}` }))
        },
        {
            label: 'Guests',
            options: presenters.guests.map(presenter => ({ value: presenter._id, label: `${presenter.firstName} ${presenter.lastName}` }))
        }
    ]

    const handleUserChange = async (selectedOption) => {
        let wasPlaying = isPlaying;
        let lastTime = time; // Save the current timer value
        // console.log(`LastTime: ${lastTime}, wasPlaying: ${wasPlaying}`)

        if (wasPlaying) {
            await handleStop();
        }
        try {
            if (currentItem.roleAssignmentId === undefined || currentItem.roleAssignmentId === null) {
                // Role assignment does not exist, create it
                const createResponse = await fetch(`${url}/roleAssignment/${meetingId}`, {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${authUser.token}`,
                    },
                    body: JSON.stringify({
                        role: currentItem.meetingRole._id,
                        user: selectedOption.value,
                    }),
                });
                // Check if the role assignment exists
                if (createResponse.status === 201 || createResponse.status === 200) {
                    // toast.success('Role assignment created successfully', { position: 'bottom-left' });
                    // Update the assigned user details in the item object
                    const updatedUser = presenters.officersAndMembers
                        .concat(presenters.guests)
                        .find(user => user._id === selectedOption.value);

                    if (updatedUser) {
                        currentItem.assignedUser = {
                            avatar: updatedUser.avatar || null,
                            firstName: updatedUser.firstName,
                            lastName: updatedUser.lastName,
                        };
                    }
                    setSelectedPresenterId(selectedOption);
                    setShowDropdown(false); // Hide the dropdown after selection
                } else {
                    throw new Error('Failed to create role assignment');
                }
            }
            else {
                const roleAssignmentResponse = await fetch(`${url}/roleAssignment/${currentItem.roleAssignmentId}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });
                if (roleAssignmentResponse.status === 200) {
                    // Role assignment exists, update it
                    const updateResponse = await fetch(`${url}/roleAssignment/${currentItem.roleAssignmentId}`, {
                        method: 'PATCH',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${authUser.token}`,
                        },
                        body: JSON.stringify({
                            user: selectedOption.value,
                        }),
                    });

                    if (updateResponse.status === 200) {
                        // Update the assigned user details in the item object
                        const updatedUser = presenters.officersAndMembers
                            .concat(presenters.guests)
                            .find(user => user._id === selectedOption.value);

                        if (updatedUser) {
                            currentItem.assignedUser = {
                                avatar: updatedUser.avatar || null,
                                firstName: updatedUser.firstName,
                                lastName: updatedUser.lastName,
                            };
                        }

                        // toast.success('User assignment updated', { position: 'bottom-left' });
                        setSelectedPresenterId(selectedOption);
                        setShowDropdown(false); // Hide the dropdown after selection
                    } else {
                        throw new Error('Failed to update user assignment');
                    }
                } else {
                    throw new Error('Unexpected response while checking role assignment');
                }
            }

        } catch (err) {
            toast.error('' + err, { position: 'bottom-left' });
        }
        await getMeeting()
        if (wasPlaying) {
            // Find the updated currentItem
            const updatedIndex = agenda.findIndex(agendaItem => agendaItem.agendaItemId === item.agendaItemId);
            const updatedItem = agenda[updatedIndex];

            // If the new user has no timer, set it to lastTime
            if (!updatedItem.timer || updatedItem.timer.time === 0) {
                setTime(lastTime);
            } else {
                setTime(updatedItem.timer.time);
            }
            setIsPlaying(true);
        }
    };

    useEffect(() => {
        // Use item.timer to initialize the timer state
        if (currentItem?.timer) {
            setTime(currentItem.timer.time || 0); // Set the timer state to the saved time
            setIsInitial(false); // Ensure the timer is not in the initial state
            setIsLocked(currentItem.timer.locked || false); // Update the locked state

            // Resume the timer if it was running
            if (currentItem.timer.isPlaying) {
                setIsPlaying(true);
            }
        } else {
            // Timer does not exist, reset to 00:00
            setTime(0);
            setIsInitial(true); // Set the timer to the initial state
            setIsLocked(false); // Ensure the timer is not locked
            setIsPlaying(false); // Ensure the timer is not playing
        }
    }, [currentItem]);

    const toggleDropdown = () => {
        setShowDropdown(!showDropdown);
        if (!showDropdown) {
            getPresenters(); // Fetch users when the dropdown is opened
        }
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (showDropdown && dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                toggleDropdown(); // Close the dropdown if clicked outside
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
        // eslint-disable-next-line
    }, [showDropdown]); // Re-run the effect when showDropdown changes


    const handleStop = async () => {
        setIsPlaying(false); // Stop the timer
        setIsInitial(false); // Ensure the timer is not in the initial state
        try {
            let timerData;
            // console.log(currentItem?.timer)
            if (currentItem.timer) {
                // console.log(currentItem.timer.time)
                // Timer exists, update it
                const updateResponse = await fetch(`${url}/timer/${currentItem.agendaItemId}`, {
                    method: 'PATCH',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${authUser.token}`,
                    },
                    body: JSON.stringify({
                        event: currentItem.agendaEvent.name,
                        name: `${currentItem.assignedUser?.firstName || 'TBA'} ${currentItem.assignedUser?.lastName || ''}`,
                        time: time, // Use the current time state
                    }),
                });

                if (updateResponse.status === 200 || updateResponse.status === 201) {
                    timerData = await updateResponse.json();
                    // toast.success('Time record updated', { position: 'bottom-left' });
                } else {
                    throw new Error('Failed to update time record');
                }
            } else {
                // Timer does not exist, create a new one
                const createResponse = await fetch(`${url}/timer/${currentItem.agendaItemId}`, {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${authUser.token}`,
                    },
                    body: JSON.stringify({
                        event: currentItem.agendaEvent.name,
                        name: `${currentItem.assignedUser?.firstName || 'TBA'} ${currentItem.assignedUser?.lastName || ''}`,
                        time: time, // Use the current time state
                    }),
                });

                if (createResponse.status === 200 || createResponse.status === 201) {
                    timerData = await createResponse.json();
                    // toast.success('Time record saved', { position: 'bottom-left' });
                } else {
                    throw new Error('Failed to save time record');
                }
            }

            // Update the timer state with the saved data
            setTime(timerData.time);
        } catch (err) {
            toast.error('' + err, { position: 'bottom-left' });
        }
        getMeeting()
    };

    const handleReset = async () => {
        setIsPlaying(false)
        setIsInitial(true)
        setIsLocked(false) // Ensure buttons reappear after reset
        try {
            const resetTimerResponse = await fetch(`${url}/timer/${currentItem.agendaItemId}`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${authUser.token}`
                }
            })
            if (resetTimerResponse.status === 200) {
                setTime(0)
                setBackgroundColor("rgba(0, 0, 0, 0)") // Reset background color
                currentItem.time = null;
                // toast.success('Timer reset', { position: 'bottom-left' })
            }
            else {
                throw new Error('Failed to reset timer')
            }
        } catch (err) {
            toast.error('' + err, { position: 'bottom-left' })
        }
        getMeeting()
    }

    // const handleLock = async () => {
    //     try {
    //         const updateResponse = await fetch(`${url}/timer/${item.agendaItem.agendaItemId}`, {
    //             method: 'PATCH',
    //             headers: {
    //                 'Content-Type': 'application/json',
    //                 'Authorization': `Bearer ${authUser.token}`
    //             },
    //             body: JSON.stringify({
    //                 locked: true
    //             })
    //         })
    //         if (updateResponse.status === 200 || updateResponse.status === 201) {
    //             // const timerData = await updateResponse.json()
    //             setIsLocked(true)
    //             toast.success('Time record updated', { position: 'bottom-left' })
    //         } else {
    //             throw new Error('Failed to update time record')
    //         }
    //     }
    //     catch (err) {
    //         toast.error('' + err, { position: 'bottom-left' })
    //     }

    // }

    useEffect(() => {
        if (isPlaying) {
            intervalRef.current = setInterval(() => {
                setTime(prevTime => prevTime + 1)
            }, 1000)
        } else {
            clearInterval(intervalRef.current)
        }
        return () => clearInterval(intervalRef.current)
    }, [isPlaying])

    useEffect(() => {
        const { green, amber, red } = currentItem?.agendaEvent || {};

        // Convert only non-null values to seconds
        const greenTime = green ? convertToSeconds(green) : null;
        const amberTime = amber ? convertToSeconds(amber) : null;
        const redTime = red ? convertToSeconds(red) : null;

        if (redTime !== null && time >= redTime) {
            setBackgroundColor("#dc3545"); // Red
        } else if (amberTime !== null && time >= amberTime) {
            setBackgroundColor("#ffc107"); // Amber
        } else if (greenTime !== null && time >= greenTime) {
            setBackgroundColor("#146c43"); // Green
        } else {
            setBackgroundColor("rgba(0, 0, 0, 0)"); // Default
        }
    }, [time, currentItem?.agendaEvent]);

    // useEffect(() => {

    //     // Use currentItem.timer to initialize the timer state
    //     if (currentItem?.timer) {
    //         setTime(currentItem.timer.time || 0); // Set the timer state to the saved time
    //         setIsInitial(false); // Ensure the timer is not in the initial state
    //         setIsLocked(currentItem.timer.locked || false); // Update the locked state

    //         // Resume the timer if it was running
    //         if (currentItem.timer.isPlaying) {
    //             setIsPlaying(true);
    //         }
    //     } else {
    //         // Timer does not exist, reset to 00:00
    //         setTime(0);
    //         setIsInitial(true); // Set the timer to the initial state
    //         setIsLocked(false); // Ensure the timer is not locked
    //         setIsPlaying(false); // Ensure the timer is not playing
    //     }
    // }, [currentItem?.timer, currentItem?.assignedUser]);

    const convertToSeconds = (timeString) => {
        const [minutes, seconds] = timeString.split(':').map(Number)
        return minutes * 60 + seconds
    }

    const formatTime = (time) => {
        const minutes = Math.floor(time / 60)
        const seconds = time % 60
        return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
    }

    const customStyles = {
        control: (provided) => ({
            ...provided,
            backgroundColor: '#343a40',
            color: '#fff',
        }),
        menu: (provided) => ({
            ...provided,
            backgroundColor: '#343a40',
            color: '#fff',
        }),
        singleValue: (provided) => ({
            ...provided,
            color: '#fff',
        }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected ? '#495057' : state.isFocused ? '#495057' : '#343a40',
            color: '#fff',
        }),
        input: (provided) => ({
            ...provided,
            color: '#fff',
        }),
        placeholder: (provided) => ({
            ...provided,
            color: '#6c757d',
        }),
    }

    return (
        <div>
            <Button variant="link" onClick={handleShowModal} style={{ padding: 0, border: 'none', background: 'none' }} className='me-4 float-end' >
                <i className='bi bi-clock' style={{ fontSize: '25px', color: 'white' }}></i>
            </Button>
            <Modal
                centered
                show={showModal}
                onHide={handleCloseModal}
                className='text-center'
                data-bs-theme={'dark'}
                fullscreen
            // size={'xl'}
            >
                <Modal.Header className='timer-header'>
                    <Row>
                        <Col>
                            <h2 className='text-inline'> {currentItem?.meetingTheme}  </h2>
                        </Col>
                    </Row>
                </Modal.Header>
                <Modal.Body style={{ background: 'linear-gradient( #003f61 -100%, #78222f 151.58%)', position: 'relative' }} className='timer-header'>
                    <Row>
                        <Col>
                            <h1 className='golden-text mb-2' onClick={toggleRoleDescription} style={{ cursor: 'pointer' }}>{currentItem?.meetingRole.name} <ArrowRightCircle className='arrowcircle' /> </h1>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <div dangerouslySetInnerHTML={{ __html: currentItem?.meetingRole.description }} style={{ display: showRoleDescription ? 'block' : 'none' }}></div>
                        </Col>
                    </Row>
                    <Row className='limits'>
                        <Col style={{ backgroundColor: "#146c43", color: "#ffffff", textAlign: "center" }}>{currentItem?.agendaEvent.green}</Col>
                        <Col style={{ backgroundColor: "#ffc107", color: "#000000", textAlign: "center" }}>{currentItem?.agendaEvent.amber}</Col>
                        <Col style={{ backgroundColor: "#dc3545", color: "#ffffff", textAlign: "center" }}>{currentItem?.agendaEvent.red}</Col>
                    </Row>
                    <Row>
                        <Col>
                            <h4 className='text-inline'>{currentItem?.startTime}</h4>
                            <h1 onClick={toggleEventDescription} className='text-inline' style={{ cursor: 'pointer' }}> {currentItem?.agendaEvent.name} <ArrowRightCircle className='arrowcircle' /> </h1>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={1} lg={3}></Col>
                        <Col dangerouslySetInnerHTML={{ __html: currentItem?.agendaEvent.description }} style={{ display: showEventDescription ? 'block' : 'none' }}></Col>
                        <Col xs={1} lg={3}></Col>
                    </Row>
                    <Row className="mt-1 timer-colors" style={{ background: backgroundColor }} >
                        <Col >
                            <Row>
                                {/* {(item.agendaItem.assignedUser) ? */}
                                <Col>
                                    <Row>
                                        <Col xs={12}>
                                            <Row className='avatar justify-content-center'>
                                                <Col className='hexagon'>
                                                    {!currentItem?.assignedUser?.avatar
                                                        ? <Image src={userImg} style={{ height: '85%', width: '90%' }} />
                                                        : <Image src={'data:image/png;base64,' + currentItem?.assignedUser.avatar} />
                                                    }
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col>
                                            <Row>
                                                <Col>
                                                    <h1 onClick={toggleDropdown} style={{ cursor: 'pointer' }}>
                                                        {currentItem?.assignedUser?.firstName.toUpperCase() || 'TBA'}
                                                    </h1>
                                                    <h5 onClick={toggleDropdown} style={{ cursor: 'pointer' }}>
                                                        {currentItem?.assignedUser?.lastName.toUpperCase() || 'TBA'}
                                                    </h5>
                                                    <p></p>
                                                    {showDropdown && (
                                                        <div ref={dropdownRef}>
                                                            <Select
                                                                options={presenterOptions}
                                                                className='mb-3 formInput'
                                                                name='presenter'
                                                                value={presenterOptions.flatMap(group => group.options).find(option => option.value === selectedPresenterId) || ''}
                                                                onChange={handleUserChange}
                                                                isClearable
                                                                isSearchable
                                                                styles={customStyles}
                                                                placeholder='Select a presenter'
                                                            />
                                                        </div>
                                                    )}
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Col>
                                {showClock ?
                                    <Col xs={12} lg={6} className='d-flex justify-content-center align-items-center'>
                                        <p className='clock'>{formatTime(time)}</p>
                                    </Col>
                                    : ''
                                }
                            </Row>
                            <Row className="mt-3 mb-5">
                                <Col>
                                    {!isLocked && (
                                        <>
                                            {isPlaying ? (
                                                <Button variant="danger" className="me-2" onClick={handleStop} style={{ padding: '0 40px' }}>
                                                    <i className="bi bi-stop-fill" style={{ fontSize: '40px' }}></i>
                                                    {/* <span style={{ fontSize: '40px' }}>Stop</span> */}
                                                </Button>
                                            ) : (
                                                <>
                                                    {isInitial ? (
                                                        <Button variant="success" className="me-2" onClick={togglePlayPause} style={{ padding: '0 40px' }}>
                                                            <i className="bi bi-play-fill" style={{ fontSize: '40px' }}></i>
                                                            {/* <span style={{ fontSize: '40px' }}>Start</span> */}
                                                        </Button>
                                                    ) : (
                                                        <>
                                                            <Button variant="success" className="me-2" onClick={togglePlayPause} style={{ padding: '0 40px' }}>
                                                                <i className="bi bi-play-fill" style={{ fontSize: '40px' }}> </i>
                                                                {/* <span style={{ fontSize: '40px' }}>Resume</span> */}
                                                            </Button>
                                                            <Button variant="secondary" className='me-2' onClick={handleReset} style={{ padding: '0 40px' }}>
                                                                <i className='bi bi-arrow-clockwise' style={{ fontSize: '40px' }}></i>
                                                                {/* <span style={{ fontSize: '40px' }}>Reset</span> */}
                                                            </Button>
                                                            {/* <Button variant="secondary" className='me-2' onClick={handleLock}>
                                                                <i className='bi bi-lock-fill' style={{ fontSize: '40px' }}> </i>
                                                                <span style={{ fontSize: '40px' }}>Lock Timer</span>
                                                            </Button> */}
                                                        </>
                                                    )}

                                                </>
                                            )}
                                        </>
                                    )}
                                </Col>
                            </Row>
                            <Row >
                                <Col>
                                    <Button variant="info" onClick={toggleShowClock} className='me-2'>
                                        {showClock ?
                                            <>
                                                <i className="bi bi-eye-slash mb-4" style={{ fontSize: '16px' }}></i>&nbsp;
                                                Hide Clock
                                            </>
                                            :
                                            <>
                                                <i className="bi bi-eye" style={{ fontSize: '16px' }}></i>&nbsp;
                                                Show Clock
                                            </>
                                        }
                                    </Button>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Modal.Body >
                <Modal.Footer className="d-flex justify-content-between">
                    {!isPlaying &&
                        <>
                            <div style={{ justifyContent: 'flex-start' }} className='float-start'>
                                <Button
                                    onClick={handlePreviousItem}
                                    disabled={currentIndex === 0}
                                    className="me-2"
                                >
                                    Previous
                                </Button>
                                <Button
                                    onClick={handleNextItem}
                                    disabled={currentIndex === agenda.length - 1}
                                >
                                    Next
                                </Button>
                            </div>
                            <div style={{ justifyContent: 'flex-end' }} className='float-end'>
                                <Button variant='success' onClick={handleCloseModal}>
                                    Close
                                </Button>
                            </div>
                        </>}

                </Modal.Footer>
            </Modal >
        </div>
    )
}